import { render } from "./TransportationForm.vue?vue&type=template&id=234a528c"
import script from "./TransportationForm.vue?vue&type=script&lang=js"
export * from "./TransportationForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__